import React, { Component } from 'react'

import './style.css'
export class index extends Component {
  render() {
    return (
      <div>Video player</div>
    )
  }
}

export default index